<template>
  <div>
    <b-col class="text-left">
      <router-link :to="{ name: 'AllSubscription' }">
        <b-button pill variant="purple" class="ml-1 "
        >اشتراک ها
        </b-button
        >
      </router-link>


      <b-button pill v-b-modal.create-subscription-item class="mx-2">ساخت ایتم اشتراک</b-button>

      <b-modal id="create-subscription-item" hide-footer>
        <manage-subscription-item @loadItems="loadSubscription" :subscription="form"/>
      </b-modal>

      <form @submit.prevent="onSubmit">

        <b-form-row dir="rtl" class="justify-content-center">
          <div class="col-lg-4 mx-auto text-center">

            <form-group class="col text-right mb-3" :validations="$v.form.name">
              <div slot-scope="{ errors, invalid }">
                <label>نام اشتراک</label>

                <input v-model="form.name" type="text" class="form-control">

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>
            <form-group class="col text-right mb-3" :validations="$v.form.slug">
              <div slot-scope="{ errors, invalid }">
                <label>slug</label>
                <input v-model="form.slug" type="text" class="form-control">

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>
            <form-group class="col text-right mb-3" :validations="$v.form.value_type">
              <div slot-scope="{ errors, invalid }">
                <label>نوع اشتراک</label>
                <select v-model="form.value_type" class="form-control">

                  <option value="date">روز</option>
                  <option value="number">عدد</option>


                </select>

                <form-errors-manager :errors="errors"/>


              </div>
            </form-group>
            <button class="btn rounded-pill text-center btn-primary px-5">ثبت</button>
          </div>
        </b-form-row>
      </form>
      <hr>

      <div v-if="updateMode" dir="rtl" class="text-right">
        <table class="table-striped table-responsive-md table-responsive-sm">
          <thead class="fon">
          <tr>
            <th>شناسه</th>
            <th>اسم</th>
            <th>قیمت</th>
            <th>تخفیف</th>
            <th>اعتبار</th>
            <th>ویرایش / حذف</th>

          </tr>
          </thead>
          <tr v-for="item in form.subscription_items  ">
            <th class="font-weight-light">{{ item.id }}</th>
            <th class="font-weight-light">{{ item.name }}</th>
            <th class="font-weight-light">{{ formatNumber(item.price) }}</th>
            <th class="font-weight-light">{{ formatNumber(item.offer) }}</th>
            <th class="font-weight-light">{{ item.value }}</th>
            <th>


              <b-icon v-b-modal="`subscription-item-modal-${item.id}`" icon="pencil"
                      class="mx-3 text-info cursor-pointer font-size-2"></b-icon>


              <b-modal :id="`subscription-item-modal-${item.id}`" hide-footer>
                <manage-subscription-item @loadItems="loadSubscription" :subscription="form" :item="item"/>
              </b-modal>


              <b-icon @click="deleteSubscriptionItem(item)" icon="trash"
                      class="mr-4 cursor-pointer text-danger"></b-icon>
            </th>
          </tr>
        </table>
      </div>


    </b-col>
  </div>
</template>


<script>
import {required} from "vuelidate/lib/validators";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FormGroup from "../../../components/validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import ManageSubscriptionItem from "./ManageSubscriptionItem.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";


export default {
  name: "BaseSubscriptionForm",
  components: {ManageSubscriptionItem, FormErrorsManager, FormGroup},
  data() {
    return {
      form: {
        name: '',
        slug: '',
        value_type: '',
        subscription_items: [],
      },
    }
  },
  validations: {
    form: {
      name: {required},
      slug: {required},
      value_type: {required},
    },
  },
  computed: {
    updateMode() {
      return this.$route.params.id != undefined
    }

  },
  methods: {
    formatNumber,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async createSubscription() {
      let req = await this.$store.dispatch('Subscription/creatSubscription', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      await this.$router.push({name: "UpdateSubscription", params: {id: itemId}})
    },
    async loadSubscription() {
      let form = {
        id: this.$route.params.id
      }
      let req = await this.$store.dispatch('Subscription/getSubscription', form)
      this.form = req.data.data
    },
    async updateSubscription() {
      let req = await this.$store.dispatch('Subscription/updateSubscription', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')

    },
     deleteSubscriptionItem(item) {
      let req =  this.$store.dispatch('Subscription/deleteSubscriptionItem', item)
      req.then(res => {
        this.loadSubscription()
        toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      })
    },
    onSubmit() {

      if (!this.invalid()) {
        return false
      }

      if (this.updateMode) { // update mode
        this.updateSubscription()
      } else { // create mode
        this.createSubscription()
      }

    }
  },
  mounted() {
    if (this.updateMode) {
      this.loadSubscription()
    }
  }


}

</script>


<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.font-size-2 {
  font-size: 20px;
}
</style>